var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-custom-checkerboard-create"
  }, [_c('div', {
    staticClass: "ugc-custom-checkerboard-create-wrapper"
  }, [_c('button', {
    staticClass: "button ugc-tray-wrapper-button",
    style: {
      'background-image': "url(".concat(_vm.$store.state.endPoints.customizer.customsAssets, "/images/customizer/checkerboard_cta_bg.png)")
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disableButton
    },
    on: {
      "click": _vm.clicked
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textLabel) + "\n    ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }